export function isUndef(n){return"undefined"===n}export function isMiniApp(){return!isUndef(typeof my)&&null!==my&&!isUndef(typeof my.alert)}